import React, { useState, useRef, useEffect } from 'react'
import { useCookies } from 'react-cookie';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as common from "../Common/common";
import * as Comp from "../Common/CommonComponents";
import CssClass from "../Styles/common.module.css";
import { GetPageAuthorityFn } from "../Common/authority";
import { GetDashboardViewAllPermissionFn } from "../Common/authority";
import http from "../Common/http-common";
import "bootstrap/dist/css/bootstrap.min.css";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleUser } from "@fortawesome/free-solid-svg-icons";
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import startOfWeek from 'date-fns/startOfWeek'
import getDay from 'date-fns/getDay'
import Year from '../Components/Dashboard/Year.js'
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const PAGE_NAME = "Dashboard.js_";
const MODULE_ID = "WEB_DB_001";

const Dashboard = () => {
	document.title = common.c_TITLE + " - Dashboard";

	const navigate = useNavigate();
	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const [userName] = useState(cookies.USERNAME);
	const calendarRef = useRef(null); 
	const [events, setEvents] = useState([]);
	const [allData, setAllData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingText, setLoadingText] = useState("Loading...");
	const [reload, setReload] = useState(false);
	const [errorMsg, setErrorMsg] = useState("");
	const currentYear = new Date().getFullYear();
	const [selectedYear, setSelectedYear] = useState(currentYear);
	const [date, setDate] = useState(new Date());
	const [currentView, setCurrentView] = useState("month");
	const [selectedEvent, setSelectedEvent] = useState(null);
	const [showModal, setShowModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
	const locales = {
		'en-US': require('date-fns/locale/en-US'),
	}
	
	const localizer = dateFnsLocalizer({
		format,
		parse,
		startOfWeek,
		getDay,
		locales,
	})
	localizer.formats.yearHeaderFormat = 'yyyy'

	const handleNavigate = (newDate, view, action) => {
  const year = newDate.getFullYear();
		if (year < 2025) {
			return;
		}
		setDate(newDate);
	};
	
	const CustomEvent = ({ event }) => {
		const tooltipId = `event-tooltip-${event.id}`;
		const isHoliday = event.isHoliday === 'holiday';

		const tooltipContent = `<div style="background-color: #fff; padding: 0; border: 1px solid #ccc; border-radius: 8px; width: 100%;">
															<div style="background-color: #DEDEDE; padding: 8px 12px; font-weight: bold; border-bottom: 1px solid #ccc;">
																${event.title}${event.isHoliday === "holiday" ? "" : " Leave"}
															</div>
														</div>`;

		return (
			<>
				<div 
					data-tooltip-id={tooltipId} 
					// data-tooltip-content={`${event.title}`} 
					data-tooltip-html={tooltipContent}
        	title=""
        	style={{ 
						display: isHoliday ? '' : 'flex',
          	color: isHoliday ? 'black' : '#fff',
          	fontWeight: 'bold',
						fontSize: isHoliday ? '12px' : '11px',
						borderRadius: isHoliday ? '' : '50%',
						cursor: 'pointer',
						whiteSpace: 'normal',
						overflow: 'visible',
						textOverflow: 'ellipsis',
						wordBreak: 'break-word', 
						gap: '4px',
						padding: '0 4px',
					}}
				>
					{!isHoliday && (
						<span style={{
							display: "inline-flex",
							alignItems: "center",
							justifyContent: "center",
							backgroundColor: event.title === "Annual" 
															 ? "#006600": 
															 event.title === "Medical"
															 ? "#003399"
															 : event.title === "Unpaid"
															 ? "#a50021"
															 : event.title === "Emergency"
															 ? "#680a39"
															 : "#99002f",
							color: "#fff",
							width: "13px",
							height: "12px",
							borderRadius: "50%",
							fontSize: "10px",
							fontWeight: "bold",
              flexShrink: 0,
						}}>
							{event.count}
						</span>
					)}
					{ 
						event.title === "Annual" ? " AL" : 
						event.title === "Medical" ? " ML" : 
						event.title === "Unpaid" ? " UL" : 
						event.title === "Emergency" ? " EL" : 
						event.title 
					}
				</div>
				<Tooltip id={tooltipId} place="right" positionStrategy="fixed"
					style={{ 
						color: 'black', 
						backgroundColor: '#fff', 
						borderRadius: '6px',
						fontSize: '16px', 
						padding: 0, 
						border: 'none',
						boxShadow: '0 0 10px rgba(0,0,0,0.15)',
					}}/>
			</>
		);
	};

	const CustomDateHeader = ({ label, date }) => {
		const isSameDay = (d1, d2) =>
			d1.getFullYear() === d2.getFullYear() &&
			d1.getMonth() === d2.getMonth() &&
			d1.getDate() === d2.getDate();

		const isHoliday = events.some(event =>
			event.isHoliday === "holiday" && isSameDay(new Date(event.start), date)
		);

		return (
			<span style={{ fontWeight: isHoliday ? 'bold' : 'normal', color: isHoliday ? 'black' : 'inherit' }}>
				{label}
			</span>
		);
	};

	const [viewData, setViewData] = useState('OWN');

	const [actionAuthority, setActionAuthority] = useState({
		READ: "N",
		WRITE: "N",
	});

  const [viewAuthority, setViewAuthority] = useState({
    VIEWALL: "N",
  });

	// #region AuthorityCheck
	useEffect(() => {
		let promise = GetPageAuthorityFn(userId, MODULE_ID);
		promise.then(
			(result) => {
				setActionAuthority(result);
				if (result.READ === "N") {
					navigate("/");
				}
			},
			(error) => {
				setActionAuthority({
					READ: "N",
					WRITE: "N",
				});
				common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
				toast.error(error);
				navigate("/");
			}
		);
	}, [userId, navigate]);

  useEffect(() => {
    let promise = GetDashboardViewAllPermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setViewAuthority(result);
      },
      (error) => {
        setViewAuthority({
          VIEWALL: "N",

        });
        common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
        toast.error(error);
      }
    );
  }, [actionAuthority, userId])
	//#endregion

	useEffect(() => {
		if (userId && userName) {
			// Do Nothing
		}
		else {
			// navigate("/Login");
			window.location = common.c_getWebLoginUrl() + "Login";
		}
	}, [userId, userName]);

	//#region Leave Entitlement
	useEffect(() => {
		let functionName = "";
		try {
			functionName = "Get User Leave Entitlement";
			setLoading(true);
			setLoadingText("Table Loading, please wait...");
			const listItems = [];
				
			http
			.get("api/home/GetUserLeaveEntitlement?_sysUser=" + 
				userId +
				"&_year=" +
				selectedYear, { timeout: 10000000 })
			.then((response) => {
				if (response.data.length > 0) {
					response.data.forEach((data, counter) => {
						listItems.push({
							key: data.USER_MST_GUID,
							ANNUAL_LEAVE_BRINGFORWARD: data.ANNUAL_LEAVE_BRINGFORWARD,
							ANNUAL_LEAVE_ENTITLED: data.ANNUAL_LEAVE_ENTITLED,
							ANNUAL_LEAVE_TAKEN: data.ANNUAL_LEAVE_TAKEN,
							ANNUAL_LEAVE_TOTAL_ENTITLEMENT: data.ANNUAL_LEAVE_TOTAL_ENTITLEMENT,
							ANNUAL_LEAVE_BALANCE: Math.max(0, data.ANNUAL_LEAVE_BALANCE ?? 0),
							ANNUAL_LEAVE_MTD_BALANCE: Math.max(0, data.ANNUAL_LEAVE_MTD_BALANCE ?? 0),
              MEDICAL_LEAVE_ENTITLED: data.MEDICAL_LEAVE_ENTITLED,
              MEDICAL_LEAVE_TAKEN: data.MEDICAL_LEAVE_TAKEN,
							MEDICAL_LEAVE_BALANCE: Math.max(0, data.MEDICAL_LEAVE_BALANCE ?? 0),
							MEDICAL_LEAVE_MTD_BALANCE: Math.max(0, data.MEDICAL_LEAVE_MTD_BALANCE ?? 0),
              UNPAID_LEAVE_TAKEN: data.UNPAID_LEAVE_TAKEN,
              MEDICAL_CLAIM_ENTITLED: data.MEDICAL_CLAIM_ENTITLED,
              MEDICAL_CLAIMED: data.MEDICAL_CLAIMED,
							MEDICAL_CLAIM_BALANCE: Math.max(0, data.MEDICAL_CLAIM_BALANCE ?? 0),
              SUBMITTED_COUNT: data.SUBMITTED_COUNT,
              APPROVED_COUNT: data.APPROVED_COUNT,
              REJECTED_COUNT: data.REJECTED_COUNT,
						});
					});
					setAllData(listItems);
				}
			})
			.catch((err) =>{
				toast.error("Error on getting user leave entitlement. Please try again.");
				common.c_LogWebError(PAGE_NAME, functionName, err);
			})
      .finally(() => {
        setLoading(false);
        setLoadingText("Loading...");
      });
		} catch (err) {
			setErrorMsg("Failed fetching leave entitlement.");
			common.c_LogWebError(PAGE_NAME, functionName, err);
		}
	},[reload, userId, selectedYear])
	//#endregion

	//#region Calendar
	useEffect(() => {
		if (calendarRef.current) {
			let functionName = "";
			setLoading(true);
			setLoadingText("Calendar Loading, please wait...");
			const tempEvents = [];
			const HolidayList = [];
			try {
				functionName = "Get Holiday";
				http
					.get(
						"api/home/GetHoliday?_sysUser=" +
						userId,
						{ timeout: 10000000 }
					)
					.then((response) => {
						if (response.data.length > 0) {
							response.data.forEach((data, counter) => {
								HolidayList.push({
									title: data.HOLIDAY_NAME,
									start: new Date(data.HOLIDAY_DATE),
  								end: new Date(data.HOLIDAY_DATE),
									leave_session: "",
									isHoliday: "holiday",
									color: '#d86ecc',
								});
							});
							tempEvents.push(...HolidayList);
						} 
						else {
							setErrorMsg("Error: Data status is not successful.");
						}
					})
					.catch((err) => {
						setErrorMsg("Error fetching events.");
						common.c_LogWebError(PAGE_NAME, functionName, err);
					})
					.finally(() => {
						setLoading(false);
						setLoadingText("Loading...");
					});
			} catch (err) {
				setErrorMsg("Failed fetching events.");
				common.c_LogWebError(PAGE_NAME, functionName, err);
			}

			const LeaveList = [];
			try {
				functionName = "Get Leave Application";
				setLoading(true);
				setLoadingText("Calendar Loading, please wait...");
							
				const viewAll =
							viewData === "ALL"
							? ""
							: userId;
								
				http
					.get(
						"api/home/GetLeaveApplication?_sysUser=" +
						userId +
						"&_viewAll=" +
						viewAll,
						{ timeout: 10000000 }
					)
					.then((response) => {
						if (response.data.length > 0) {
							let filteredData = response.data;

							filteredData.forEach((data) => {
								const endDate = new Date(data.END_DATE);
								endDate.setDate(endDate.getDate() + 1);
						
								LeaveList.push({
									id: data.LEAVE_MST_ID,
									title: data.LEAVE_TYPE,
									username: data.USERNAME,
									start: new Date(data.START_DATE),
									end: endDate,
									leave_type: data.LEAVE_TYPE,
									leave_session: data.LEAVE_SESSION,
									isHoliday: "",
									color: data.COLOR_BG,
								});
							});
							tempEvents.push(...LeaveList);
						} 
						else {
							setErrorMsg("Error: Data status is not successful.");
						}
					})
					.catch((err) => {
						setErrorMsg("Error fetching events.");
						common.c_LogWebError(PAGE_NAME, functionName, err);
					})
					.finally(() => {
						setEvents(tempEvents);
						setLoading(false);
						setLoadingText("Loading...");
					});
				} catch (err) {
					setErrorMsg("Failed fetching events.");
					common.c_LogWebError(PAGE_NAME, functionName, err);
				}
		}
	}, [reload, userId, viewData]);
	// #endregion

	//#region Toggle
	const onReloadHandler = () => {
		setReload(!reload);
	};

	const onLoadingHandler = (load, text) => {
		setLoading(load);
		setLoadingText(text);
	};
	
	const handleChange = (e) => {
		const newView = e.target.checked ? "ALL" : "OWN";
		setViewData(newView);
		setReload(!reload);
	};

  const hideModal = () => {
    setShowModal(false);
  };

	const groupEvents = (events) => {
		const leavePriority = {
			Annual: 1,
			Medical: 2,
			Unpaid: 3,
			Emergency: 4
		};

		const dailyEvents = [];

		const holidayDates = new Set(
			events
				.filter(e => e.isHoliday === 'holiday')
				.map(e => new Date(e.start).toDateString())
		);

		events.forEach(event => {
			if (event.isHoliday === 'holiday') {
				dailyEvents.push(event);
				return;
			}

			const start = new Date(event.start);
			const end = new Date(event.end);
			end.setDate(end.getDate() - 1);

			const temp = new Date(start);
			while (temp <= end) {
				const thisDate = new Date(temp);
				const day = thisDate.getDay();

				if (day === 0 || day === 6) {
					temp.setDate(temp.getDate() + 1);
					continue;
				}

				const dateKey = thisDate.toDateString();

				if (holidayDates.has(dateKey)) {
					temp.setDate(temp.getDate() + 1);
					continue;
				}

				dailyEvents.push({
					...event,
					start: new Date(thisDate),
					end: new Date(thisDate.getFullYear(), thisDate.getMonth(), thisDate.getDate() + 1),
					clickedDate: new Date(thisDate),
				});

				temp.setDate(temp.getDate() + 1);
			}
		});

		const mergedMap = {};

		dailyEvents.forEach(event => {
			const key = `${event.start.toDateString()}|${event.leave_type}`;
			if (!mergedMap[key]) {
				mergedMap[key] = {
					...event,
					usernames: [event.username],
					count: 1,
				};
			} else {
				mergedMap[key].usernames.push(event.username);
				mergedMap[key].count += 1;
			}
		});

		const result = Object.values(mergedMap);

		return result.sort((a, b) => {
			const dateA = new Date(a.start);
			const dateB = new Date(b.start);
			const aPriority = leavePriority[a.title] || 99;
			const bPriority = leavePriority[b.title] || 99;

			if (dateA.getTime() === dateB.getTime()) {
				return aPriority - bPriority;
			}
			return dateA - dateB;
		});
	};

	useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
	//#endregion

	//#region Return
	return (
		<>
		<div className="Panel" style={{ padding: "8px" }}>
			<div className="leftpanel">
				<div className="leave-day-box">
					<h4 style={{ marginLeft: "5px", fontWeight: "bold" }}>Leave Status</h4>
					<div style={{ display: "flex", justifyContent: "center" }}>
						<Comp.Button
							id="btnPending"
							type="general"
							style={{ 
								border: '1px solid #ccc',
								backgroundColor: '#ffcc00', 
								width: '300px', 
								height: '44px', 
								fontWeight: 'bold', 
								fontSize: '15px',
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'center',
								padding: '5px',
							}}
						>
							<span>PENDING</span>
							<span style={{ fontSize: "16px" }}>{allData[0]?.SUBMITTED_COUNT || 0}</span>
						</Comp.Button>
						<Comp.Button
							id="btnApproved"
							type="general"
							style={{ 
								border: '1px solid #ccc',
								backgroundColor: '#33cc33', 
								width: '300px', 
								height: '44px', 
								fontWeight: 'bold', 
								fontSize: '15px',
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'center',
								padding: '5px',
							}}
						>
							<span>APPROVED</span>
							<span style={{ fontSize: "16px" }}>{allData[0]?.APPROVED_COUNT || 0}</span>
						</Comp.Button>
						<Comp.Button
							id="btnRejected"
							type="general"
							style={{ 
								border: '1px solid #ccc',
								backgroundColor: '#ff9999', 
								width: '300px', 
								height: '44px', 
								fontWeight: 'bold', 
								fontSize: '15px',
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'center',
								padding: '5px',
							}}
						>
							<span>REJECTED</span>
							<span style={{ fontSize: "16px" }}>{allData[0]?.REJECTED_COUNT || 0}</span>
						</Comp.Button>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: "3px" }}>
						<h4 style={{ marginLeft: "5px", fontWeight: "bold" }}>Summary</h4>

						<div>
							<button
								onClick={() => setSelectedYear(prev => prev - 1)}
								disabled={selectedYear <= 2025}
								style={{
									background: '#fff',
									color: '#373a3c',
									border: '1px solid #ccc',
									borderRadius: '4px',
									fontSize: '16px',
									cursor: 'pointer',
									padding: '2px 8px',
									transition: 'background 0.3s'
								}}
							>
								&lt;
							</button>

							<span style={{ fontSize: '16px', fontWeight: 'bold', margin: '0 15px' }}>
								{selectedYear}
							</span>

							<button
								onClick={() => setSelectedYear(prev => prev + 1)}
								style={{
									background: '#fff',
									color: '#373a3c',
									border: '1px solid #ccc',
									borderRadius: '4px',
									fontSize: '16px',
									cursor: 'pointer',
									padding: '2px 8px',
									transition: 'background 0.3s'
								}}
							>
								&gt;
							</button>
						</div>
					</div>
          <div style={{
            border: '1px solid #ddd',
            borderRadius: '10px',
            padding: '4px 6px',
            marginBottom: '5px',
            backgroundColor: '#f9f9fc',
						height: '110px',
          }}>
            <p style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold', marginBottom: '0' }}>Annual Leave</p>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ textAlign: 'left', minWidth: '60px', fontSize: '14px' }}>
                <p style={{ margin: 0, fontWeight: 'bold' }}>Taken</p>
                <p style={{ margin: 0, fontWeight: 'bold' }}>{allData[0]?.ANNUAL_LEAVE_TAKEN || '0'}</p>
              </div>

              <div style={{ flex: 1, margin: '0 10px' }}>
                <div style={{
                  height: '10px',
                  background: '#e0e0f0',
                  borderRadius: '10px',
                  overflow: 'hidden',
  								// direction: 'rtl'
                }}>
                  <div style={{
                    width: `${(allData[0]?.ANNUAL_LEAVE_ENTITLED > 0)
											? (100 - ((allData[0]?.ANNUAL_LEAVE_TAKEN / allData[0]?.ANNUAL_LEAVE_TOTAL_ENTITLEMENT) * 100))
											: 0}%`,
                    height: '100%',
                    background: 'linear-gradient(to right, #6a85f1, #a67efb)',
    								borderRadius: '10px 0 0 10px',
                    transition: 'width 0.3s ease'
                  }}>
                	</div>
                </div>
              </div>

              <div style={{ textAlign: 'right', minWidth: '60px', fontSize: '14px' }}>
                <p style={{ margin: 0, fontWeight: 'bold' }}>YTD Bal</p>
                <p style={{ margin: 0, fontWeight: 'bold' }}>{allData[0]?.ANNUAL_LEAVE_BALANCE || '0'}</p>
              </div>
            </div>

            <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: 'bold' }}>
              <div>BF</div>
              <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', textAlign: 'center' }}>Yearly Entitled</div>
              <div>MTD Bal</div>
            </div>
            <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: 'bold' }}>
              <div>{allData[0]?.ANNUAL_LEAVE_BRINGFORWARD || '0'}</div>
              <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', textAlign: 'center' }}>{allData[0]?.ANNUAL_LEAVE_ENTITLED || '0'}</div>
              <div>{allData[0]?.ANNUAL_LEAVE_MTD_BALANCE || '0'}</div>
            </div>
          </div>
          <div style={{
            border: '1px solid #ddd',
            borderRadius: '10px',
            padding: '4px 6px',
            marginBottom: '5px',
            backgroundColor: '#f9f9fc',
						height: '110px',
          }}>
            <p style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold', marginBottom: '0' }}>Medical Leave</p>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ textAlign: 'left', minWidth: '60px', fontSize: '14px' }}>
                <p style={{ margin: 0, fontWeight: 'bold' }}>Taken</p>
                <p style={{ margin: 0, fontWeight: 'bold' }}>{allData[0]?.MEDICAL_LEAVE_TAKEN || '0'}</p>
              </div>

              <div style={{ flex: 1, margin: '0 10px' }}>
                <div style={{
                  height: '10px',
                  background: '#e0e0f0',
                  borderRadius: '10px',
                  overflow: 'hidden',
  								// direction: 'rtl'
                }}>
                  <div style={{
                    width: `${(allData[0]?.MEDICAL_LEAVE_ENTITLED > 0)
											? (100 - ((allData[0]?.MEDICAL_LEAVE_TAKEN / allData[0]?.MEDICAL_LEAVE_ENTITLED) * 100))
											: 0}%`,
                    height: '100%',
                    background: 'linear-gradient(to right, #6a85f1, #a67efb)',
    								borderRadius: '10px 0 0 10px',
                    transition: 'width 0.3s ease',
                  }}>
									</div>
								</div>
							</div>

              <div style={{ textAlign: 'right', minWidth: '60px', fontSize: '14px' }}>
                <p style={{ margin: 0, fontWeight: 'bold' }}>Bal</p>
                <p style={{ margin: 0, fontWeight: 'bold' }}>{allData[0]?.MEDICAL_LEAVE_BALANCE || '0'}</p>
              </div>
            </div>

            <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: 'bold' }}>
              <div></div>
              <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', textAlign: 'center' }}>Yearly Entitled</div>
              <div></div>
            </div>
            <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: 'bold' }}>
              <div></div>
              <div style={{ position: 'absolute', top: '20px', left: '50%', transform: 'translateX(-50%)', textAlign: 'center' }}>{allData[0]?.MEDICAL_LEAVE_ENTITLED || '0'}</div>
              <div></div>
            </div>
          </div>
          <div style={{
            border: '1px solid #ddd',
            borderRadius: '10px',
            padding: '4px 6px',
            marginBottom: '5px',
            backgroundColor: '#f9f9fc',
						height: '110px'
          }}>
            <p style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold', marginBottom: '0' }}>Medical Claim</p>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ textAlign: 'left', minWidth: '60px', fontSize: '14px' }}>
                <p style={{ margin: 0, fontWeight: 'bold' }}>Claimed</p>
                <p style={{ margin: 0, fontWeight: 'bold' }}>RM {allData[0]?.MEDICAL_CLAIMED || '0'}</p>
              </div>

              <div style={{ flex: 1, margin: '0 10px' }}>
                <div style={{
                  height: '10px',
                  background: '#e0e0f0',
                  borderRadius: '10px',
                  overflow: 'hidden',
                }}>
                  <div style={{
                    width: `${(allData[0]?.MEDICAL_CLAIM_ENTITLED > 0)
											? (100 - ((allData[0]?.MEDICAL_CLAIMED / allData[0]?.MEDICAL_CLAIM_ENTITLED) * 100))
											: 0}%`,
                    height: '100%',
                    background: 'linear-gradient(to right, #6a85f1, #a67efb)',
    								borderRadius: '10px 0 0 10px',
                    transition: 'width 0.3s ease',
                  }}>
									</div>
								</div>
							</div>

              <div style={{ textAlign: 'right', minWidth: '60px', fontSize: '14px' }}>
                <p style={{ margin: 0, fontWeight: 'bold' }}>Bal</p>
                <p style={{ margin: 0, fontWeight: 'bold' }}>RM {allData[0]?.MEDICAL_CLAIM_BALANCE || '0'}</p>
              </div>
            </div>

            <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: 'bold' }}>
              <div></div>
              <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', textAlign: 'center' }}>Yearly Entitled</div>
              <div></div>
            </div>
            <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: 'bold' }}>
              <div></div>
              <div style={{ position: 'absolute', top: '20px', left: '50%', transform: 'translateX(-50%)', textAlign: 'center' }}>RM {allData[0]?.MEDICAL_CLAIM_ENTITLED || '0'}</div>
              <div></div>
            </div>
          </div>
					<div style={{
            border: '1px solid #ddd',
            borderRadius: '10px',
            padding: '4px 6px',
            backgroundColor: '#f9f9fc',
						height: '110px',
          }}>
            <p style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold', marginBottom: '0' }}>Unpaid Leave</p>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ textAlign: 'left', minWidth: '60px' }}>
                <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold' }}>Taken</p>
                <p style={{ margin: 0, fontWeight: 'bold' }}>{allData[0]?.UNPAID_LEAVE_TAKEN || '0'}</p>
              </div>

              <div style={{ flex: 1, margin: '0 10px' }}>
                <div style={{
                  height: '10px',
                  background: '#e0e0f0',
                  borderRadius: '10px',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    width: `${(allData[0]?.UNPAID_LEAVE_TAKEN > 0) ? '100%' : '0%'}`,
                    height: '100%',
                    background: 'linear-gradient(to right, #6a85f1, #a67efb)',
    								borderRadius: '10px 0 0 10px',
                    transition: 'width 0.3s ease'
                  }}>
                	</div>
                </div>
              </div>

              <div style={{ textAlign: 'right', minWidth: '60px', fontSize: '15px' }}>
                <p style={{ margin: 0, fontWeight: 'bold' }}></p>
                <p style={{ margin: 0, fontWeight: 'bold' }}></p>
              </div>
            </div>

            <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: 'bold' }}>
              <div></div>
              <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', textAlign: 'center' }}></div>
              <div></div>
            </div>
            <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: 'bold' }}>
              <div></div>
              <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', textAlign: 'center' }}></div>
              <div></div>
            </div>
          </div>
        </div>
			</div>
			<div className="rightpanel">
				{(viewAuthority.VIEWALL === 'Y') && (
					<div style={{width: "100%"}}>
						<div className={CssClass.toggleWrapper} style={{ display: "flex", marginTop: "5px", float: "right", fontFamily: "Aptos, sans-serif" }}>
							<h5 style={{ margin: 0 }}><b>All</b></h5>
							<label className={CssClass.switchAll} style={{ marginLeft: "10px" }}>
								<input
									type="checkbox"
									checked={viewData === "ALL"}
									onReload={onReloadHandler}
									onChange={(e) => handleChange(e)}
									disabled={currentView === "year"}
								/>
								<span className={CssClass.sliderRoundAll}></span>
							</label>
						</div>
					</div>
				)}
				<div style={{ display: 'flex' }}>
					<Comp.Button
						id="btnH"
						type="general"
						style={{ 
							backgroundColor: '#d86ecc', 
							width: isMobile ? '40px' : '50px', 
							height: '30px', 
							fontWeight: 'bold', 
							fontSize: '14px',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center' 
						}}
					>
						H
					</Comp.Button>
					<Comp.Button
						id="btnAL"
						type="general"
						style={{ 
							backgroundColor: '#47d45a', 
							width: isMobile ? '40px' : '50px', 
							height: '30px', 
							fontWeight: 'bold', 
							fontSize: '14px' ,
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center'
						}}
					>
						AL
					</Comp.Button>
					<Comp.Button
						id="btnML"
						type="general"
						style={{ 
							backgroundColor: '#46b1e1', 
							width: isMobile ? '40px' : '50px', 
							height: '30px', 
							fontWeight: 'bold', 
							fontSize: '14px' ,
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center'
						}}
					>
						ML
					</Comp.Button>
					<Comp.Button
						id="btnUL"
						type="general"
						style={{ 
							backgroundColor: '#ff7c80', 
							width: isMobile ? '40px' : '50px', 
							height: '30px', 
							fontWeight: 'bold', 
							fontSize: '14px' ,
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center'
						}}
					>
						UL
					</Comp.Button>
					<Comp.Button
						id="btnUL"
						type="general"
						style={{ 
							backgroundColor: '#ff0000', 
							width: isMobile ? '40px' : '50px', 
							height: '30px', 
							fontWeight: 'bold', 
							fontSize: '14px',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center'
						}}
					>
						EL
					</Comp.Button>
				</div>

				<div>
					<Calendar
            ref={calendarRef}
						localizer={localizer}
						date={date}
						onNavigate={handleNavigate}
						startAccessor="start"
						endAccessor="end"
						onView={(view) => {
								setCurrentView(view);
								if (view === "year") {
									setViewData("OWN");
								}
							}}
						events={groupEvents(events)}
						eventPropGetter={(event) => {
							const isHoliday = event.isHoliday === "holiday";

							if (!isHoliday) {
								return {
									style: {
										backgroundColor: event.color,
										color: "#fff",
										borderRadius: "4px",
										padding: "1px 2px",
										overflow: "hidden",
										textOverflow: "ellipsis",
										lineHeight: '1.3',
									}
								};
							}

							return {
								style: {
									backgroundColor: "transparent"
								}
							};
						}}
						dayPropGetter={(date) => {
							const holidayEvent = events.some(event =>
								event.isHoliday === "holiday" &&
								new Date(event.start).toDateString() === date.toDateString()
							);

							if (holidayEvent) {
								return {
									style: {
										backgroundColor: "#d86ecc",
        						boxShadow: "inset 0 0 0 1px black"
									}
								};
							}
							return {};
						}}
						components={{ event: CustomEvent, month: { dateHeader: CustomDateHeader }}}
						onSelectEvent={(event) => {
							const clickedDate = new Date(event.clickedDate || event.start);

							if (event.isHoliday !== "holiday") {
								setSelectedEvent({ ...event, clickedDate });
								setShowModal(true);
							}
						}}
						style={{ height: '535px', marginTop: '10px' }}
						views={{
							year: Year,
							month: true,
							week: false,
							day: false
						}}
						messages={{ year: 'Year' }}
						min={new Date(2025, 0, 1)}
					/>
				</div>
			</div>
		</div>
		
    <Modal show={showModal} onHide={hideModal} centered size="lg">
      <Modal.Body>
      	<div className="leave-modal">
					{selectedEvent && (() => {
						const clickedDate = new Date(selectedEvent.clickedDate).toDateString();
						const leaveTypeOrder = ["Annual", "Medical", "Unpaid", "Emergency"];
						const leaveTypeMap = {};

						events.forEach((event) => {
							const start = new Date(event.start);
							const end = new Date(event.end);
							end.setDate(end.getDate() - 1);
							const eventDates = [];

							while (start <= end) {
								eventDates.push(new Date(start).toDateString());
								start.setDate(start.getDate() + 1);
							}

							if (eventDates.includes(clickedDate)) {
								const key = event.leave_type;
								if (!leaveTypeMap[key]) {
									leaveTypeMap[key] = {
										leave_type: key,
										color: event.color,
										usernames: [event.username],
									};
								} else {
									leaveTypeMap[key].usernames.push(event.username);
								}
							}
						});

						const sortedLeaveGroups = Object.values(leaveTypeMap).sort((a, b) => {
							return leaveTypeOrder.indexOf(a.leave_type) - leaveTypeOrder.indexOf(b.leave_type);
						});

						const namesPerRow = isMobile ? 2 : 3;

						return (
    					<div>
								{sortedLeaveGroups.map((group, groupIndex) => (
									<div key={groupIndex} style={{ marginBottom: "20px" }}>
										<h5
											style={{
												backgroundColor: group.color,
												padding: "8px",
												borderRadius: "6px",
												fontWeight: "bold",
												color: "#fff",
                        fontSize: isMobile ? "16px" : "18px",
											}}
										>
											{group.leave_type} Leave
										</h5>

										{group.usernames
											.reduce((rows, name, i) => {
												if (i % namesPerRow  === 0) rows.push([]);
												rows[rows.length - 1].push(name);
												return rows;
											}, [])
											.map((row, rowIndex) => (
												<div
													key={rowIndex}
													style={{
														display: "flex",
														justifyContent: "space-between",
														marginLeft: "5px",
														marginBottom: "12px",
														marginTop: "10px",
													}}
												>
													{Array.from({ length: namesPerRow }).map((_, i) => (
														<div
															key={i}
                          		className="username"
															style={{
																flex: "1",
																visibility: row[i] ? "visible" : "hidden",
																display: "flex",
																alignItems: "center",
																justifyContent: "flex-start",
                                paddingLeft: i === 0 ? "0" : isMobile ? "20px" : "40px",
                                fontSize: isMobile ? "12px" : "16px",
															}}
														>
															{row[i] && (
																<>
																	<FontAwesomeIcon icon={faCircleUser} size="lg" style={{ marginRight: "6px" }}/> {row[i]}
																</>
															)}
														</div>
													))}
												</div>
											))}
									</div>
								))}
							</div>
						)
					})()}
				</div>
      </Modal.Body>
   	</Modal>

		{loading && <Comp.Loading>{loadingText}</Comp.Loading>}
		<Comp.AlertPopup />
	</>
	);
	//#endregion
};

export default Dashboard;